export interface Category {
  id: string;
  name: string;
  url: string;
}

export const categories: Category[] = [
  { id: "shoes", name: "Shoes", url: "https://kaspreadsheet.com/category-911-Shoes.html" },
  { id: "hoodies", name: "Hoodies/Sweaters", url: "https://kaspreadsheet.com/search-912/name/Shoes.html" },
  { id: "tshirts", name: "T-Shirts", url: "https://kaspreadsheet.com/search-913/name/Shoes.html" },
  { id: "jackets", name: "Jackets", url: "https://kaspreadsheet.com/search-914/name/Shoes.html" },
  { id: "pants", name: "Pants/Shorts", url: "https://kaspreadsheet.com/search-915/name/Shoes.html" },
  { id: "headwear", name: "Headwear", url: "https://kaspreadsheet.com/search-916/name/Shoes.html" },
  { id: "sets", name: "Sets", url: "https://kaspreadsheet.com/search-917/name/Shoes.html" },
  { id: "underwear", name: "Underwear/Underpants", url: "https://kaspreadsheet.com/search-918/name/Shoes.html" },
  { id: "jersey", name: "Jersey", url: "https://kaspreadsheet.com/search-919/name/Shoes.html" },
  { id: "accessories", name: "Accessories", url: "https://kaspreadsheet.com/search-920/name/Shoes.html" },
  { id: "bags", name: "Bags", url: "https://kaspreadsheet.com/search-921/name/Shoes.html" },
  { id: "belts", name: "Belts", url: "https://kaspreadsheet.com/search-922/name/Shoes.html" },
  { id: "perfumes", name: "Perfumes", url: "https://kaspreadsheet.com/search-923/name/Shoes.html" },
  { id: "other", name: "Other Stuff", url: "https://kaspreadsheet.com/search-924/name/Shoes.html" },
];